import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import "./ClientDetails.css";
import Sidebar from "./sidebar";

const ClientDetails = () => {
  const [client, setClient] = useState(null);
  const [contracts, setContracts] = useState([]);
  const [selectedContracts, setSelectedContracts] = useState({});
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}v1/client_contracts/${id}`, {
        headers: {
          "x-api-key": "12345xxa",
        },
      })
      .then((res) => {
        console.log("Данные клиента и договоров:", res.data);
        if (res.data.length > 0) {
          const clientData = {
            client_name: res.data[0].client_name || 'Не указано',
            client_bin: res.data[0].client_bin || 'Не указано',
            client_address: res.data[0].client_address || 'Не указано',
            client_phone: res.data[0].client_phone || 'Не указано',
            client_email: res.data[0].client_email || 'Не указано',
          };
          console.log("Данные клиента:", clientData);
          setClient(clientData);
          setContracts(res.data.map(item => ({
            id: item.contract_id,
            contract_number: item.contract_number,
            contract_date: item.contract_date,
            remaining_amount: item.remaining_amount,
          })));
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Ошибка при получении данных о клиенте и договорах:", error);
        setLoading(false);
      });
  }, [id]);

  const handleAddContract = () => {
    navigate(`/CreateContract`);
  };

  const handleCheckboxChange = (contractId) => {
    setSelectedContracts((prevSelectedContracts) => ({
      ...prevSelectedContracts,
      [contractId]: !prevSelectedContracts[contractId],
    }));
  };

  const handleDeleteContract = () => {
    const contractIdsToDelete = Object.keys(selectedContracts).filter(id => selectedContracts[id]);
    Promise.all(
      contractIdsToDelete.map(contractId => 
        axios.delete(`${process.env.REACT_APP_API_URL}v1/contracts/${contractId}`, {
          headers: {
            "x-api-key": "12345xxa",
          },
        })
      )
    )
    .then(() => {
      setContracts((prevContracts) =>
        prevContracts.filter((contract) => !contractIdsToDelete.includes(contract.id.toString()))
      );
      setSelectedContracts({});
    })
    .catch((error) => {
      console.error("Ошибка при удалении договоров:", error);
    });
  };


  return (
    <div className="main-container-client-details">
      <div className="sidebar-client-details">
        <Sidebar />
      </div>
      <div className="content-client-details">
        {loading ? (
          <div>Загрузка...</div>
        ) : client ? (
          <div className="client-details">
            <div className="clientdetails-header">
              <h1 className="client-name">{client.client_name}</h1>
              <div className="client-info">
                <div><span>БИН:</span> {client.client_bin}</div>
                <div><span>Адрес:</span> {client.client_address}</div>
                <div><span>Телефон:</span> {client.client_phone}</div>
                <div><span>E-mail:</span> {client.client_email}</div>
              </div>
            </div>
          </div>
        ) : (
          <div>Данные о клиенте не найдены.</div>
        )}

        <div className="contracts">
          <h2>Договора</h2>
          <div className="contract-list">
            <table className="order-items">
              <thead>
                <tr>
                  <th></th>
                  <th>Номер договора</th>
                  <th>Дата</th>
                  <th>Оставшаяся сумма</th>
                </tr>
              </thead>
              <tbody className="order-itemss">
                {contracts.map((contract) => (
                  <tr key={contract.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={!!selectedContracts[contract.id]}
                        onChange={() => handleCheckboxChange(contract.id)}
                      />
                    </td>
                    <td>
                      <Link to={`/ClientsList/ClientDetails/ContractDetails/${contract.id}`} className="contract-link">
                        {contract.contract_number}
                      </Link>
                    </td>
                    <td>{new Date(contract.contract_date).toLocaleDateString()}</td>
                    <td>{contract.remaining_amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="contract-actions">
          <button onClick={handleAddContract} disabled>Добавить договор</button>
          <button onClick={handleDeleteContract} disabled>
            Удалить
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientDetails;
